import PropTypes from 'prop-types'
import {JsonViewer} from '../../../../../../../common/JsonViewer.jsx'
import {HeaderTitle} from '../../../../../../../common/HeaderTitle.jsx'
import ZrodlaFinansowaniaRepeater from "../parts/ZrodlaFinansowaniaRepeater.jsx";
import {Badge, Card, Col, Row} from "react-bootstrap";
import {toCurrency} from "../../../../../../../utils/helpers/index.js";
import React, {useMemo} from "react";
import {LabelFor} from "../../../../../../../common/inputs/LabelFor.jsx";

export const ZrodlaFinansowania = (props) => {
    const wartoscCalkowita = useMemo(() => 
        parseFloat(props.wiz?.form?.wartosc_calkowita || 0), 
        [props.wiz?.form?.wartosc_calkowita]
    );
    
    const sumaZrodel = useMemo(() => {
        const list = props.wiz?.form?.zrodla_list || [];
        return list.reduce((sum, item) => sum + parseFloat(item?.kwota || 0), 0);
    }, [props.wiz?.form?.zrodla_list]);
    
    const roznica = wartoscCalkowita - sumaZrodel;
    const isValid = Math.abs(roznica) < 0.01;

    return (
        <>
            <JsonViewer src={props.wiz?.form || {}} show={true}/>

            <HeaderTitle noHr size={'fs-3'} title={'Źródła Finansowania'}/>

            <HeaderTitle
                noHr
                size={'fs-4'}
                title={'Wprowadź informacje o źródłach finansowania projektu'}
            />

            <div className={'d-flex flex-column gap-3'}>
                <Card className={`mb-4 mt-5 p-3 border-primary`}>
                    <Card.Body>
                        <Row>
                            <Col lg={4} className="mb-3 mb-md-0 border-end px-3 d-flex flex-column justify-content-center">
                                <h4 className="text-primary fw-bold mb-2 pb-2">
                                    Szacunkowa wartość całkowita projektu (wartość zgodna z pkt C.)
                                </h4>
                                <div className="fw-bold mt-1 text-dark">
                                    <Badge bg="primary" className="fs-5 p-2">
                                        {toCurrency(wartoscCalkowita)}
                                    </Badge>
                                </div>
                            </Col>
                            <Col lg={4} className="mb-3 mb-md-0 border-end px-3 d-flex flex-column justify-content-center">
                                <h4 className="text-primary fw-bold mb-2 pb-2">
                                    Suma ze źródeł finansowania
                                </h4>
                                <div className="fw-bold mt-1 text-dark">
                                    <Badge bg="primary" className="fs-5 p-2">
                                        {toCurrency(sumaZrodel)}
                                    </Badge>
                                </div>
                            </Col>
                            <Col lg={4} className="mb-3 mb-md-0 px-3 d-flex flex-column justify-content-center">
                                <h4 className="text-primary fw-bold mb-2 pb-2">
                                    Rozbieżność do skorygowania (oczekiwana wartość "0.00")
                                </h4>
                                <div className="fw-bold mt-1 text-dark">
                                    <Badge bg={isValid ? 'primary' : roznica > 0 ? 'warning' : 'danger'} className="fs-5 p-2">
                                        {toCurrency(roznica)}
                                    </Badge>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </div>

            <div className={'d-flex flex-column gap-3'}>
                <div>
                    <LabelFor
                    id={'zrodla_list'}
                    label={props.wiz.getLabel('zrodla_list')}
                    tooltipText={props.wiz.getToolTip('zrodla_list')}
                />
                </div>

                <ZrodlaFinansowaniaRepeater wiz={props.wiz} parentListName={'zrodla_list'}/>
            </div>
        </>
    )
}

ZrodlaFinansowania.propTypes = {
    wiz: PropTypes.any,
}